import { Navigate } from 'react-router-dom';
import { useContextStore } from '../hooks/context/useContextStore';

/**
 * Smart root redirect component that handles authentication-based routing
 * - Authenticated users: redirect to /dashboard
 * - Unauthenticated users: redirect to /signin
 */
export function RootRedirect() {
  const { clientUser } = useContextStore();

  // Redirect based on authentication status
  if (clientUser) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Navigate to="/signin" replace />;
}
